// @ts-nocheck
/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { init as initApm } from '@elastic/apm-rum';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { Slide, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './state/store/Store';
import reportWebVitals from './reportWebVitals';
import App from './App';
import packageJson from '../package.json';
import { loadFont } from './utils/fontLoader';

const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

try {
  // eslint-disable-next-line no-unused-vars
  const apm = initApm({
    serviceName: `${packageJson.name}-${window.CONFIG.REACT_APP_ENV}`,

    serverUrl: `${window.CONFIG.REACT_APP_ERROR_LOGGER}`,

    // Set service version (required for sourcemap feature)
    serviceVersion: packageJson.version,
    environment: window.CONFIG.REACT_APP_ENV,
    active: window.CONFIG.NODE_ENV === 'production',
    distributedTracingOrigins: window.location.pathname,
    logLevel: 'warn',
  });
  window.apm = apm;
} catch (e) {
  // eslint-disable-next-line no-console
  console.log('Failed to start APM RUM Agent', e);
}

/**
 * Render the app
 */
const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            TransitionComponent={Slide}
            hideIconVariant={false}
            ref={notistackRef}
            action={(key) => (
              <IconButton
                aria-label="close"
                size="small"
                onClick={onClickDismiss(key)}
              >
                <CloseIcon style={{ fill: '#FFFFFF' }} color="secondary" />
              </IconButton>
            )}
          >
            <App notistackRef={notistackRef} />
          </SnackbarProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );

  reportWebVitals();
};

// Load fonts, then render app
loadFont(renderApp);
